import * as React from 'react';
import { SolidZhk16 } from '@cian/ui-kit/icons';
import { InlineText3 } from '@cian/ui-kit/typography';
import classNames from 'classnames';

import * as styles from './styles.css';

export interface IReliableLabelProps {
  light?: boolean;
  onOpen?(): void;
  onClick?(event: React.MouseEvent<HTMLElement>): void;
}

export function ReliableLabel({ onOpen, onClick, light }: IReliableLabelProps) {
  return (
    <div
      className={classNames(styles['container'], styles['reliable'], light && styles['reliable-light'])}
      onMouseEnter={onOpen}
      onClick={onClick}
    >
      <SolidZhk16 color={light ? 'primary_100' : 'white_100'} />
      <div className={styles['text']}>
        <InlineText3 color={light ? 'primary_100' : 'white_100'}>Надёжный ЖК</InlineText3>
      </div>
    </div>
  );
}
